import React from "react";
function Footer() {
  return (
    <footer className="container mx-auto py-1 fixed bottom-0 md:left-48 bg-white light:bg-light-mode bg-transparent">
      <p className="text-xs text-center text-light-content light:text-light-content w-full">
        Designed and Coded by{" "}
        <a
          className="font-medium"
          href="https://lovenui-portfolio.pages.dev"
          target="_blank"
          rel="noreferrer noopener"
        >
          Yujin Xian
        </a>{" "}
        with
        <span className="text-gradient font-medium"> Love</span> &
        <span className="text-gradient font-medium"> Coffee</span>
      </p>
    </footer>
  );
}
export default Footer;
